import React from "react";
import { List, Datagrid, TextField } from "react-admin";
import { useLocation, useNavigate } from "react-router-dom";
import LargePagination from "../core/LargePagination";
import { Box } from "@mui/system";
import { FormControl, InputLabel, MenuItem, Select, TextField as MuiTextField } from "@mui/material";

class AuditTrailFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            timeout: "",
            tableName: this.props.tableName,
            entityId: this.props.entityId,
            action: this.props.action,
        };
    }

    componentDidUpdate(prevProps, _) {
        const newTableName = "";
        if (
            prevProps.tableName != this.props.tableName ||
            prevProps.entityId != this.props.entityId ||
            prevProps.action != this.props.action
        ) {
            this.setState({
                tableName: this.props.tableName || "",
                entityId: this.props.entityId || "",
                action: this.props.action || "",
            });
        }
    }

    delayedOnChange = (ev) => {
        ev.stopPropagation();
        clearTimeout(this.state.timeout);

        this.setState({
            [ev.target.name]: ev.target.value,

            timeout: setTimeout(() => {
                let payload = {};

                if (this.state.tableName) {
                    payload.tableName = this.state.tableName;
                }

                if (this.state.entityId) {
                    payload.entityId = this.state.entityId;
                }

                if (this.state.action) {
                    payload.action = this.state.action;
                }

                this.props.onChange(payload);
            }, 1000),
        });
    };

    render() {
        return (
            <Box component="div" sx={{ minHeight: "56px" }}>
                <FormControl
                    sx={{
                        marginTop: "10px",
                        marginRight: "10px",
                        minWidth: 180,
                        maxWidth: 300,
                    }}
                >
                    <InputLabel id="tableName">Type</InputLabel>
                    <Select
                        name="tableName"
                        labelId="tableName-label"
                        value={this.state.tableName}
                        label="Table Name"
                        onChange={this.delayedOnChange}
                    >
                        <MenuItem value="" />
                        <MenuItem value="chart_series">Chart Series</MenuItem>
                        <MenuItem value="chart_subcharts">Chart Subcharts</MenuItem>
                        <MenuItem value="line_client_chart">Line Chart Assignments</MenuItem>
                        <MenuItem value="line_role_group">Line Role Group</MenuItem>
                        <MenuItem value="role_group">Role Group</MenuItem>
                        <MenuItem value="site_group_client_chart">Site Group Chart Assignments</MenuItem>
                        <MenuItem value="site_group_status">Site Group Status</MenuItem>
                        <MenuItem value="user_site_group_list">User Site Group List</MenuItem>
                    </Select>
                </FormControl>
                <MuiTextField
                    name="entityId"
                    label="Entity ID"
                    variant="filled"
                    value={this.state.entityId}
                    onChange={this.delayedOnChange}
                    sx={{
                        marginTop: "10px",
                        marginRight: "10px",
                    }}
                />
                <FormControl
                    sx={{
                        marginTop: "10px",
                        marginRight: "10px",
                        minWidth: 180,
                        maxWidth: 300,
                    }}
                >
                    <InputLabel id="action">Action</InputLabel>
                    <Select
                        name="action"
                        labelId="action-label"
                        value={this.state.action}
                        label="Action"
                        onChange={this.delayedOnChange}
                    >
                        <MenuItem value="" />
                        <MenuItem value="create">Create</MenuItem>
                        <MenuItem value="update">Update</MenuItem>
                        <MenuItem value="delete">Delete</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        );
    }
}

const buildNewUrl = (location, filterParams) => {
    const urlSearchParams = new URLSearchParams(location.search);

    urlSearchParams.set("filter", JSON.stringify(filterParams));

    if (urlSearchParams.get("filter")) {
        return `${location.pathname}?${urlSearchParams.toString()}`;
    }
    return "";
};

export const AuditTrailList = ({ ...props }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const urlSearchParams = new URLSearchParams(location.search);
    const filterParams = JSON.parse(urlSearchParams.get("filter")) || {};

    const { tableName, entityId, action } = filterParams;

    return (
        <>
            <AuditTrailFilter
                tableName={tableName}
                entityId={entityId}
                action={action}
                onChange={(newFilterParams) => {
                    navigate(buildNewUrl(location, newFilterParams));
                }}
            />
            <List title="Audit trail" perPage={500} pagination={<LargePagination />} {...props}>
                <Datagrid bulkActionButtons={false}>
                    <TextField source="tableName" label="Type" />
                    <TextField source="entityId" label="Entity ID" />
                    <TextField source="action" />
                    <TextField source="payload" />
                    <TextField source="createdAt" />
                    <TextField source="username" />
                    <TextField source="userFirstName" label="First Name" />
                    <TextField source="userLastName" label="Last Name" />
                </Datagrid>
            </List>
        </>
    );
};
